import {lazy} from "react";
import {Route} from "react-router";
import Welcome from "../../../page/Welcome";

export const webRoutes = () => {
    let routes = [
        {
            layout: Route,
            path: "/soon",
            element: <Welcome />,
        },
        {
            layout: Route,
            path: "*",
            exact: true,
            element: lazy(() => import('../../../page/NotFound'))
        }
    ]

    return routes.reduce((routes, route) => {
        if (route.hideLayout) {
            return {
                ...routes,
                withoutLayout: [...routes.withoutLayout, route]
            }
        }

        return {
            ...routes,
            withLayout: [...routes.withLayout, route]
        }
    }, { withLayout: [], withoutLayout: [] })
}
